/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateInspectionOrderDto } from '../../models/create-inspection-order-dto';
import { InspectionOrderResponseDto } from '../../models/inspection-order-response-dto';

export interface OrderControllerCreateInspectionOrder$Params {
      body: CreateInspectionOrderDto
}

export function orderControllerCreateInspectionOrder(http: HttpClient, rootUrl: string, params: OrderControllerCreateInspectionOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<InspectionOrderResponseDto>> {
  const rb = new RequestBuilder(rootUrl, orderControllerCreateInspectionOrder.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InspectionOrderResponseDto>;
    })
  );
}

orderControllerCreateInspectionOrder.PATH = '/api/order/inspection';
